export default {"src":"/_next/static/media/display-solid.fc5c0b26.svg","height":512,"width":576};